export const LOCATIONS = [
  'New York - Times Square',
  'New York - Central Park',
  'San Francisco - Union Square',
];

export const DURATIONS = [
  { label: '4 Hours - $20', value: '4h' },
  { label: '8 Hours - $35', value: '8h' },
  { label: 'Full Day - $50', value: '24h' },
];

export const DURATIONS_PRICES = {
  '4h': 20,
  '8h': 35,
  '24h': 50,
};

export const PROMO_CARDS = [
  {
    icon: '/icons/become_a_host.svg',
    title: 'Book Now',
    subtitle: 'Get $50 Free Credit!',
    button: 'Book A Botel',
    color: '#2563EB',
    bgcolor: '#003584',
  },
  {
    icon: '/icons/home_icon.svg',
    title: 'Become A Host',
    subtitle: 'Make $1,500+/mo Per Botel!',
    button: 'Start Hosting',
    color: '#22C55E',
    bgcolor: '#003584',
  },
  {
    icon: '/icons/become_a_host_icon.svg',
    title: 'Partner With Us',
    subtitle: 'Secure, Passive, Scalable Income!',
    button: 'Partner Now',
    color: '#7C3AED',
    bgcolor: '#003584',
  },
]; 